import { media } from 'ia-react-core';
import styled from 'styled-components';

export const StyledToggleButtonListWrapper = styled.div`
label,span:last-child {
  width:100%;
  ${media.sm`
    width:auto;
  `};
}

span[disabled] {
  border-color: ${({ theme }) => theme.colors.gray4} !important;
  color: ${({ theme }) => theme.colors.gray4} !important;
}
`;
